import axios from 'axios';

// 创建 axios 实例
const service = axios.create({
  timeout: 50000,
  headers: { 'Content-Type': 'application/json;charset=utf-8' }
});

const BaseUrl = 'http://test-app-api.hkautoexpo.com';
// const BaseUrl = 'http://192.168.1.106:8001'

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    if (!config.headers) {
      throw new Error(
        `Expected 'config' and 'config.headers' not to be undefined`
      );
    }
    config.baseURL = BaseUrl
    config.headers['web-path'] = window.location.href
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const { code } = response.data;
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
      return response;
    }

    if (code === 200) {
      return response.data.data;
    } else {
      // 响应数据为二进制流处理(Excel导出)
      if (response.data instanceof Blob) {
        return response;
      }
      return Promise.reject(response.data);
    }
  },
  error => {
    return Promise.reject(new Error(error || 'Error'));
  }
);

// 导出 axios 实例
export default service;
